export default __webpack_public_path__ + "static/media/content-img-5.78061798.webp";